import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { setTheuser_clientdetailsReportActions } from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";

const Userclient = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  useEffect(() => {
    if(state.clientDetailsCall.ActiveForUserProfile == 7 && state.ClientBranchIDs.userProfileId != null){
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      user_id: state.ClientBranchIDs.userProfileId,
      // authorized_person:state.ClientBranchIDs.authoriedID
    };
    dispatch(setTheuser_clientdetailsReportActions(payload));
  }
  }, [dtpageindex , state.clientDetailsCall
                                    .ActiveForUserProfile ,state.ClientBranchIDs.userProfileId , search]);


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
    setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
 
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const columns = [
{
  Header: "Client Branch",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const client = row?.row?.original;
    const branchCode = client?.branch_code ?? "";
    const clientName = client?.client_name ?? "";

    // Full label for tooltip
    const fullLabel = branchCode
      ? `${branchCode} - ${clientName}`
      : clientName;

    // Short display (truncate client name only)
    const shortName =
      clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

    const shortLabel = branchCode
      ? `${branchCode} - ${shortName}`
      : shortName;

    return (
      <>
        {client && clientName ? (
          <div
            className="UserName"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: "relative" }}
          >
            <span>{shortLabel}</span>

            {showTooltip && (
              <div className="custom-tooltip">{fullLabel}</div>
            )}
          </div>
        ) : (
          <div className="UserName">
            <span>---</span>
          </div>
        )}
      </>
    );
  },
},

     {
      Header: "State",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.state_id != null ? (
              <span>{row.row.original.state_id.state_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Region",
      accessor: "",
      Cell: (row) => {
        // console.log(row.row.original, "regions");
        return (
          // <>
          //   <span>{row.row.original.region_id.region_name}</span>
          // </>
          <div>
            <div className="IconsDesign">

              {row.row.original.region_id != null ? (
                <span>{row.row.original.region_id.region_name}</span>
              ) : (
                <span>---</span>
              )}
            </div>
          </div>
        );
      },
    },

    {
      Header: "Zone",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.zone_id != null ? (
              <span>{row.row.original.zone_id.zone_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
  ];
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);
}
};

  return (
    <>
      <ReactTable
        data={state.User_clinetDetailsListOut.User_clientDetailsDATA}
        columns={columns}
        totalItems={state.User_clinetDetailsListOut.Total_Count}
        currentPage={currentPage}
        onChange={tochange}
        setCurrentPage={setCurrentPage}
        pagesize={pagesize}
        dtpagesize={pageSize}
        dtpageindex={dtpageindex}
        pageindex={pageindex}
        onPrevious={handlePrevious}
        onNextpage={handleNext}
        GotoEnteredPage={GotoEnteredPage}

        datacount={state.User_clinetDetailsListOut.Total_Count}
        Filter={true}
             NoFilter ={true}
      />
    </>
  );
};

export default Userclient;
